/** A panel's own 20px title with an optional trailing link or status word. */
const TITLE = {
  fontSize: 'var(--t-xl)',
  fontFamily: 'var(--font-display)',
  fontWeight: 700,
  letterSpacing: -0.5,
  color: 'var(--text)',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const TRAILING = {
  fontSize: 'var(--t-sm)',
  fontFamily: 'var(--font-display)',
  fontWeight: 700,
  color: 'var(--text-3)',
  flex: '0 0 auto',
};

export function PanelHeader({ title, action, meta, onAction }) {
  if (!title && !action && !meta) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
      <div style={TITLE}>{title}</div>
      {action ? (
        <button
          type="button"
          onClick={onAction}
          style={{ ...TRAILING, background: 'none', border: 0, padding: 0, cursor: 'pointer' }}
        >
          {action.label}
        </button>
      ) : (meta ? <div style={TRAILING}>{meta}</div> : null)}
    </div>
  );
}

export default PanelHeader;
